import { gql } from "@apollo/client";
import { CartTriggerFragment } from "../cartTrigger/cartTriggerFragments.gql";
import { MiniCartFragment } from "../MiniCart/miniCartFragments.gql";

export const NOTIFY_PRODUCT = gql`
  mutation notifyProduct($product_id: Int!, $email: String!) {
    ProductAlertNotifyInStock(
      input: { product_id: $product_id, email: $email }
    ) {
      message

      id
    }
  }
`;

export const ADD_PRODUCT_TO_CART = gql`
  mutation AddProductToCart($cartId: String!, $product: CartItemInput!) {
    addProductsToCart(cartId: $cartId, cartItems: [$product]) {
      cart {
        id
        ...CartTriggerFragment
        ...MiniCartFragment
      }
      user_errors {
        code
        message
      }
    }
  }
  ${CartTriggerFragment}
  ${MiniCartFragment}
`;

export const ADD_SIMPLE_MUTATION = gql`
  mutation addSimpleProductToCart(
    $cartId: String!
    $quantity: Float!
    $sku: String!
  ) {
    addSimpleProductsToCart(
      input: {
        cart_id: $cartId
        cart_items: [{ data: { quantity: $quantity, sku: $sku } }]
      }
    ) @connection(key: "addSimpleProductsToCart") {
      cart {
        id
        ...CartTriggerFragment
        ...MiniCartFragment
      }
    }
  }
  ${CartTriggerFragment}
  ${MiniCartFragment}
`;

export const GET_VIRTUAL_PRODUCT = gql`
  query getVirtualProductQuery($eq: String!) {
    products(filter: { sku: { eq: $eq } }) {
      items {
        uid
        name
        sku
        price_range {
          minimum_price {
            regular_price {
              value
              currency
            }
            final_price {
              value
              currency
            }
            discount {
              amount_off
              percent_off
            }
          }
          maximum_price {
            regular_price {
              value
              currency
            }
            final_price {
              value
              currency
            }
            discount {
              amount_off
              percent_off
            }
          }
        }
        __typename
        ... on CustomizableProductInterface {
          options {
            title
            required
            sort_order
            uid
          }
        }
      }
    }
  }
`;

export const ADD_CONFIGURABLE_MUTATION = gql`
  mutation addConfigurableProductToCart(
    $cartId: String!
    $quantity: Float!
    $sku: String!
    $parentSku: String!
  ) {
    addConfigurableProductsToCart(
      input: {
        cart_id: $cartId
        cart_items: [
          { data: { quantity: $quantity, sku: $sku }, parent_sku: $parentSku }
        ]
      }
    ) @connection(key: "addConfigurableProductsToCart") {
      cart {
        id
        ...CartTriggerFragment
        ...MiniCartFragment
      }
    }
  }
  ${CartTriggerFragment}
  ${MiniCartFragment}
`;

export const GET_CONFIGURATIONS_QUERY = gql`
  query getConfigurations($sku: String!, $optionValueUids: [ID!]) {
    products(search: $sku) {
      items {
        ... on ConfigurableProduct {
          configurable_options {
            uid
            attribute_code
            values {
              label
              uid
            }
          }
          configurable_product_options_selection(
            configurableOptionValueUids: $optionValueUids
          ) {
            options_available_for_selection {
              attribute_code
              option_value_uids
            }
            variant {
              id
              uid
              sku
              name
            }
          }
        }
      }
    }
  }
`;

export default {
  notifyProductQuery: NOTIFY_PRODUCT,
  addProductToCartMutation: ADD_PRODUCT_TO_CART,
  addSimpleProductToCartMutation: ADD_SIMPLE_MUTATION,
  addConfigurableProductToCartMutation: ADD_CONFIGURABLE_MUTATION,
  getVirtualProductQuery: GET_VIRTUAL_PRODUCT,
  getConfigurationsQuery: GET_CONFIGURATIONS_QUERY,
};
